if (!customElements.get('products-per-page')) {
  customElements.define(
    'products-per-page',
    class ProductsPerPage extends HTMLElement {
      constructor() {
        super();
        this.select = this.querySelector('select');
        this.templateSuffix = this.dataset.templateSuffix || '';
        this.select?.addEventListener('change', this.onChange.bind(this));
      }

      onChange(event) {
        const pageSize = event.currentTarget.value;
        const url = new URL(window.location.href);

        url.searchParams.delete('page');
        url.searchParams.delete('section_id');

        const baseTemplateSuffix = this.templateSuffix.replace(/-(48|96)$/, '').replace(/^(48|96)$/, '');
        const targetView = pageSize === '24' ? baseTemplateSuffix : [baseTemplateSuffix, pageSize].filter(Boolean).join('-');

        if (targetView) {
          url.searchParams.set('view', targetView);
        } else {
          url.searchParams.delete('view');
        }

        event.currentTarget.disabled = true;
        window.location.assign(url.toString());
      }
    },
  );
}
